import React from 'react';

import PlayIcon from 'components/__atoms/play-icon';

// loading the sass style fot the component
import css from './styles.module.scss';

/**
 * Molecule Media
 *
 * A component that receives an object with media properties
 */
function Media(props) {
  const {
    className = '',
    url,
    poster,
    type = 'img',
    alt = '',
    centralizeItem = false,
    isFullContentSize = false,
    ...other
  } = props;

  const [error, setError] = React.useState(false);
  const [videoActive, setVideoActive] = React.useState(false);

  React.useEffect(() => {
    !url && setError(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const youtubeId = type === 'embed' && getYoutubeId(url);

  function getYoutubeId(url) {
    const id = url?.match('[\\?&]v=([^&#]*)')?.[1];
    return id;
  }

  function getUrl() {
    return `https://www.youtube.com/embed/${youtubeId}?autoplay=1`;
  }

  function getPoster() {
    return `https://i3.ytimg.com/vi/${youtubeId}/maxresdefault.jpg`;
  }

  return (
    <div
      className={`${css['molecule__media-container']} ${className}`}
      {...other}
      data-centralize-item={centralizeItem}
      data-is-full-content-size={isFullContentSize}
    >
      {error ? (
        console.error('Failed to render the media. The url I got was: ', url)
      ) : (
        <>
          {(type === 'img' || type === 'image') && (
            <img className={css['media-container-image']} alt={alt ? alt : ''} src={url} />
          )}

          {type === 'embed' && (
            <div className={css['embed-container']}>
              {videoActive ? (
                <iframe allow="autoplay" src={getUrl()} title={alt} />
              ) : (
                <div className={css['poster-container']}>
                  <button className={css['media-trigger']} onClick={() => setVideoActive(true)}>
                    <span data-visuallyhidden> Assistir ao vídeo {alt}</span>
                    <img
                      className={css['media-container-image']}
                      src={poster ? poster?.url : getPoster()}
                      alt={poster?.alt || alt}
                    />
                    <PlayIcon className={css['media-trigger-icon']} />
                  </button>
                </div>
              )}
            </div>
          )}

          {type === 'video' && (
            <video autoPlay muted loop playsInline className={css['media-container-image']}>
              <source src={url} />
            </video>
          )}
        </>
      )}
    </div>
  );
}

export default Media;
